import React from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import * as S from './CollectionCardAdd.styled';
import { UniversalPlusIcon } from '@/components/UI/Icons/Icons';

interface CollectionCardAddProps {
  onCreate: () => void;
}

export const CollectionCardAdd = ({ onCreate }: CollectionCardAddProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <S.Card>
      <S.Title>{t('bookmark_collections.add_collection_empty_title')}</S.Title>
      <S.Description>
        {t('bookmark_collections.add_collection_empty_description')}
      </S.Description>
      <S.AddButton onClick={onCreate}>
        <UniversalPlusIcon
          width={13}
          height={13}
          viewBox="0 0 15 14"
          fill={theme.palette.system.white}
        />
        {t('bookmark_collections.add_collection_empty_button')}
      </S.AddButton>
    </S.Card>
  );
};
